<div class="mx-auto max-w-5xl">
  <div>
    <div class="mx-0 md:mx-6 lg:mx-8">
      <h1 class="page-title mb-6 text-2xl font-bold text-fg">Info</h1>
      <div id="lesgevers">
        <h2 class="text-fg mt-0 mb-4 block text-center text-lg font-semibold">
          Lesgevers
        </h2>
        <span class="text-fg-muted block text-xl text-center"
          >Toffe lesgevers die elke les zorgen voor dikke fun.</span
        >

        <div class="mt-5 grid gap-6 sm:grid-cols-2">
          <div class="flex flex-col items-center">
            <img
              src="assets/images/Joeri.webp"
              width="563"
              height="600"
              fetchpriority="high"
              alt="Spinning-lesgever Joeri"
              class="h-auto w-full rounded-card"
            />
            <span class="block text-fg text-lg font-semibold mt-4">Joeri</span>
          </div>
          <div class="flex flex-col items-center">
            <img
              src="assets/images/Luc.webp"
              width="562"
              height="600"
              alt="Spinning-lesgever Luc"
              class="h-auto w-full rounded-card"
            />
            <span class="block text-fg text-lg font-semibold mt-4">Luc</span>
          </div>
        </div>
      </div>

      <div id="uren" class="mt-12">
        <h2 class="text-fg mt-0 mb-4 block text-center text-lg font-semibold">
          Uren
        </h2>
        <!-- One row per day, day on the left and the hours as chips on the right.
             As four equal columns of bare text the day and its times had the same
             weight and ran together into "Maandag19:0020:00". -->
        <ul
          role="list"
          class="divide-y divide-border/60 rounded-card bg-surface-card"
        >
          @for (row of schedule; track row.day) {
            <li
              class="flex items-center justify-between gap-4 px-4 py-3 sm:px-6"
            >
              <span class="font-medium text-fg-muted">{{ row.day }}</span>
              <span class="flex flex-wrap justify-end gap-2">
                @for (time of row.times; track time) {
                  <span
                    class="rounded-md bg-surface-raised px-2.5 py-1 text-sm font-semibold text-fg"
                  >
                    {{ time }}
                  </span>
                }
              </span>
            </li>
          }
        </ul>
      </div>
      <div id="prijzen" class="mt-12">
        <h2 class="text-fg mt-0 mb-4 block text-center text-lg font-semibold">
          Tarieven
        </h2>
        <p class="text-fg-muted mb-4 text-center">
          Betaal per beurt of koop een beurtenkaart. Beurten vervallen niet.
        </p>

        <div class="grid gap-6 md:mt-4 lg:grid-cols-3 lg:items-stretch">
          <div class="w-full">
            <div class="h-full">
              <div
                class="rounded-card p-6 h-full flex flex-col bg-surface-card"
              >
                <span class="text-fg block font-medium text-xl mb-2 text-center"
                  >Per beurt</span
                >
                <span class="font-bold block text-2xl text-brand text-center"
                  >€12</span
                >

                <ul class="list-none p-0 m-0 mt-6">
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Sporten op je eigen tempo</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="w-full">
            <div class="h-full">
              <div
                class="rounded-card p-6 h-full flex flex-col bg-surface-card inset-ring-2 inset-ring-brand/40"
              >
                <span
                  class="mx-auto mb-2 rounded-md bg-brand/15 px-2.5 py-1 text-xs font-semibold text-brand"
                  >Meest gekozen</span
                >
                <span class="text-fg block font-medium text-xl mb-2 text-center"
                  >10 Beurtenkaart</span
                >
                <span class="font-bold block text-2xl text-brand text-center"
                  >€9 / beurt</span
                >

                <ul class="list-none p-0 m-0 mt-6">
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Sporten op je eigen tempo</span>
                  </li>
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Voordeliger tarief</span>
                  </li>
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Beurten vervallen niet</span>
                  </li>
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Geldig voor al onze spinninglessen</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="w-full">
            <div class="h-full">
              <div
                class="rounded-card p-6 h-full flex flex-col bg-surface-card"
              >
                <span class="text-fg block font-medium text-xl mb-2 text-center"
                  >25 Beurtenkaart</span
                >
                <span class="font-bold block text-2xl text-brand text-center"
                  >€8 / beurt</span
                >

                <ul class="list-none p-0 m-0 mt-6">
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Sporten op je eigen tempo</span>
                  </li>
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Voordeligste tarief</span>
                  </li>
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Beurten vervallen niet</span>
                  </li>
                  <li class="flex items-center mb-3">
                    <app-icon
                      name="check"
                      size="size-4"
                      class="mr-2 text-brand"
                    />
                    <span>Geldig voor al onze spinninglessen</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="contact" class="mt-12">
        <div class="w-full">
          <h2 class="text-fg mt-0 mb-4 block text-center text-lg font-semibold">
            Contacteer ons
          </h2>
          <div class="text-fg-muted text-xl mb-2 text-center">
            Je kan altijd vrijblijvend langskomen of contact opnemen voor meer
            informatie
          </div>
        </div>
        <div class="mt-5 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          @for (item of content; track item.href) {
            <a
              [href]="item.href"
              [attr.target]="item.external ? '_blank' : null"
              [attr.rel]="item.external ? 'noopener' : null"
              class="flex flex-col items-center justify-center rounded-card bg-surface-card px-4 py-6 text-center hover:bg-surface-raised"
            >
              <app-icon [name]="item.icon" size="size-7" class="text-brand" />
              <span class="mt-4 mb-1 font-semibold text-fg">{{
                item.title
              }}</span>
              <span class="text-sm text-fg-muted">{{ item.info }}</span>
              <!-- The embedded Google map that used to sit under these tiles handed the
                   visitor's IP to Google on every page load, before anyone had agreed to
                   anything. It pointed at the same address this tile opens, so it is
                   gone: nothing leaves the page until someone taps. -->
              <span class="mt-2 text-sm font-medium text-brand">
                {{ item.action }}
              </span>
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</div>
